import {mergeConfig} from '../../configStore'
import {string} from '../types'
import type {TitleField, FieldReturn} from '../../types'

const defaultProps: Partial<TitleField> = {
  name: 'title',
}

export const title = (props?: TitleField, mergeProps?: Partial<TitleField>): FieldReturn =>
  string(mergeConfig('title', props, mergeProps, defaultProps))
